// =============================================================================
// features/sales/campaigns/detail/components/SettingsCadenceFieldset.tsx —
// Campos operacionais (prioridade, tentativas, intervalo, fuso, janela
// semanal) da aba Configuração — extraído de SettingsTab.tsx para manter o
// orquestrador abaixo de 200 linhas (norma anti-padrão do DS). São os únicos
// campos editáveis com a campanha `active`/`paused`.
// =============================================================================

import * as React from 'react';

import { Input } from '../../../../../components/ui/Input';
import type { SettingsFormValues } from '../useCampaignSettingsForm';

import { WeeklyWindowEditor } from './WeeklyWindowEditor';

export interface SettingsCadenceFieldsetProps {
  values: SettingsFormValues;
  isFieldAllowed: (
    key: 'priority' | 'maxAttempts' | 'minIntervalMinutes' | 'timezone' | 'weeklyWindow',
  ) => boolean;
  setField: <K extends keyof SettingsFormValues>(key: K, value: SettingsFormValues[K]) => void;
}

export function SettingsCadenceFieldset({
  values,
  isFieldAllowed,
  setField,
}: SettingsCadenceFieldsetProps): React.JSX.Element {
  return (
    <fieldset className="flex flex-col gap-4">
      <legend className="font-sans text-xs font-semibold uppercase tracking-wide text-ink-3 mb-1">
        Cadência e prioridade
      </legend>
      <div className="grid grid-cols-1 sm:grid-cols-3 gap-4">
        <Input
          id="settings-priority"
          type="number"
          label="Prioridade"
          min={0}
          max={1000}
          value={values.priority}
          disabled={!isFieldAllowed('priority')}
          onChange={(e) => setField('priority', Number(e.target.value) || 0)}
        />
        <Input
          id="settings-max-attempts"
          type="number"
          label="Tentativas máximas"
          min={1}
          max={50}
          value={values.maxAttempts}
          disabled={!isFieldAllowed('maxAttempts')}
          onChange={(e) => setField('maxAttempts', Number(e.target.value) || 1)}
        />
        <Input
          id="settings-min-interval"
          type="number"
          label="Intervalo mínimo (min)"
          min={0}
          max={10080}
          value={values.minIntervalMinutes}
          disabled={!isFieldAllowed('minIntervalMinutes')}
          onChange={(e) => setField('minIntervalMinutes', Number(e.target.value) || 0)}
        />
      </div>
      <Input
        id="settings-timezone"
        label="Fuso horário (IANA)"
        value={values.timezone}
        disabled={!isFieldAllowed('timezone')}
        onChange={(e) => setField('timezone', e.target.value)}
      />
      <WeeklyWindowEditor
        value={values.weeklyWindow}
        disabled={!isFieldAllowed('weeklyWindow')}
        onChange={(w) => setField('weeklyWindow', w)}
      />
    </fieldset>
  );
}
